// components/Spinner.jsx
import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium' }) => {
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium',
    large: 'spinner-large'
  };

  const spinnerClass = `spinner ${sizeClasses[size] || 'spinner-medium'}`;

  return (
    <div className={spinnerClass}>
      <div className="spinner-inner"></div>
    </div>
  );
};

export default Spinner;